module.exports = __webpack_public_path__ + "static/media/Nunu_0.007d08cc.jpg";